import React from "react";

export default function Hero() {
  return (
    <section className="bg-neutral-950 text-white py-24">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
          Empowering Your Business with Reliable IT Solutions
        </h1>
        <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-8">
          Smartguy Technologies provides personalized IT consulting for individuals and small to medium-sized businesses.
        </p>
        <a
          href="#contact"
          className="inline-block bg-orange-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition"
        >
          Get a Free Consultation
        </a>
      </div>
    </section>
  );
}
